import { ApiResponse } from 'apisauce';

import { IBranchGateway } from './branchBase';

import { GatewayResponse, ProtectedRoute } from '~types/gateway';
import {
    TCreateNewBranchAPIParams,
    TCreateNewRegionAPIParams,
    TEditBranchDetailsParams,
    TEditRegionDetailsParams,
    TGetAllBranchesAPIResponse,
    TGetAllRegionsAPIResponse,
    TGetBranchesChangeHistoryAPIParams,
    TGetBranchesChangeHistoryAPIResponse,
    TGetBranchListingAPIParams,
    TGetBranchListingAPIResponse,
    TGetRegionListingAPIParams,
    TGetRegionListingAPIResponse,
} from '~types/feat/branch';

import UtilFunctions from '~utils/functions';

const { API: { getHeaders } } = UtilFunctions;

export default class BranchGateway extends IBranchGateway {
    async getBranchListing(params: TGetBranchListingAPIParams): GatewayResponse<TGetBranchListingAPIResponse> {
        const { authToken, ...restOfGetBranchListingAPIParams } = params;
        const response: ApiResponse<TGetBranchListingAPIResponse> = await this.api.get('/branch/getBranchListing', restOfGetBranchListingAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async getRegionListing(params: TGetRegionListingAPIParams): GatewayResponse<TGetRegionListingAPIResponse> {
        const { authToken, ...restOfGetRegionListingAPIParams } = params;
        const response: ApiResponse<TGetRegionListingAPIResponse> = await this.api.get('/region/getRegionListing', restOfGetRegionListingAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async createNewRegion(params: TCreateNewRegionAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfCreateNewRegionAPIParams } = params;
        const response: ApiResponse<null> = await this.api.post('/region/createRegion', restOfCreateNewRegionAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async createNewBranch(params: TCreateNewBranchAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfCreateNewBranchAPIParams } = params;
        const response: ApiResponse<null> = await this.api.post('/branch/createBranch', restOfCreateNewBranchAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async getAllRegions(params: ProtectedRoute): GatewayResponse<TGetAllRegionsAPIResponse> {
        const { authToken } = params;
        const response: ApiResponse<TGetAllRegionsAPIResponse> = await this.api.get('/region/getRegionFilter', {}, getHeaders(authToken));
        return this.process(response);
    }

    async getAllBranches(params: ProtectedRoute): GatewayResponse<TGetAllBranchesAPIResponse> {
        const { authToken } = params;
        const response: ApiResponse<TGetAllBranchesAPIResponse> = await this.api.get('/branch/getBranchFilter', {}, getHeaders(authToken));
        return this.process(response);
    }

    async editBranchDetails(params: TEditBranchDetailsParams): GatewayResponse<string | null> {
        const { authToken, ...restOfCreateNewBranchAPIParams } = params;
        const response: ApiResponse<string | null> = await this.api.put('/branch/editBranchDetails', restOfCreateNewBranchAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async editRegionDetails(params: TEditRegionDetailsParams): GatewayResponse<string | null> {
        const { authToken, ...restOfCreateNewBranchAPIParams } = params;
        const response: ApiResponse<string | null> = await this.api.put('/region/editRegionDetails', restOfCreateNewBranchAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async getBranchesChangeHistoryListing(params: TGetBranchesChangeHistoryAPIParams): GatewayResponse<TGetBranchesChangeHistoryAPIResponse> {
        const { authToken, ...restOfParams } = params;
        const response: ApiResponse<TGetBranchesChangeHistoryAPIResponse> = await this.api.get('/branch/getBranchChangeHistoryListing', restOfParams, getHeaders(authToken));
        return this.process(response);
    }
}
